import { createSelector } from '@reduxjs/toolkit';

import { organizationModel } from '@/entities/organization';
import { patientModel } from '@/entities/patient';

// NOTE: Obtaining IDs of doctors for a specific patient, and using these IDs to retrieve complete data of the doctors within the organization
export const selectAllPatientDoctors = (patientID: string) =>
  createSelector(
    patientModel.selectors.selectTreatingDoctorsIDs(patientID),
    organizationModel.selectors.selectAllDoctors,
    (treatingStaffIDs, allDoctors) => {
      return allDoctors?.filter((staff) =>
        treatingStaffIDs?.includes(staff.ID),
      );
    },
  );

// NOTE: Obtaining IDs of treating doctors for a specific patient, and using these IDs to retrieve complete data of the doctors within the organization.
// Uses selectAllTreatingDoctors (includes inactive) so deactivated doctors remain visible in the patient card.
export const selectPatientTreatingDoctors = (patientID: string) =>
  createSelector(
    patientModel.selectors.selectTreatingDoctorsIDs(patientID),
    organizationModel.selectors.selectAllTreatingDoctors,
    (patientDoctorsIDs, treatingDoctors) => {
      return treatingDoctors?.filter((staff) =>
        patientDoctorsIDs?.includes(staff.ID),
      );
    },
  );
